export const QueryKey = {
  GET_AUTH_USER : "GET AUTH USER",
  CACHE_CHANGED_DATA_SUSTAINABILITY: "CACHE CHANGED DATA",
  PREV_WASHED_COUNT_KEY: "PREV_WASHED_COUNT_KEY",
}